"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlPoint2dNaturalLogTransformComponent = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@visualization-tools/core");
const rc_js_util_1 = require("rc-js-util");
const i_gl_indexed_point2d_binder_1 = require("../../indexed-point-2d/i-gl-indexed-point2d-binder");
const point2d_natural_log_transform_shader_1 = require("./point2d-natural-log-transform-shader");
const cartesian2d_natural_log_transform_1 = require("./cartesian2d-natural-log-transform");
/**
 * @public
 * Applies natural log to an indexable gl connector. The behavior of the transform is undefined if any point is less than 0.
 */
class GlPoint2dNaturalLogTransformComponent {
    constructor(point2dBinder) {
        this.point2dBinder = point2dBinder;
        this.config = new rc_js_util_1.Vec2.f32();
        this.bindings = {
            feedbackTransform: new core_1.GlTransformFeedback(),
            configUniform: new core_1.GlVec2Uniform("point2dNaturalLogTransform_config", this.config),
        };
        this.specification = core_1.GlProgramSpecification.mergeProgramSpecifications([
            this.point2dBinder.specification,
            new core_1.GlProgramSpecification(core_1.GlShader.combineShaders([
                point2d_natural_log_transform_shader_1.point2dNaturalLogTransformShader,
                transformShader,
            ]), core_1.dummyGlProgramSpecification.fragmentShader),
        ]);
    }
    getCacheId() {
        return [
            "logFeedbackTransform",
            this.point2dBinder.getTransformId(),
        ].join("_");
    }
    initialize(transformRenderer) {
        this.point2dBinder.initialize(transformRenderer);
        this.bindings.feedbackTransform.initialize(transformRenderer);
        this.bindings.configUniform.initialize(transformRenderer);
    }
    resetState() {
        this.point2dBinder.resetState();
    }
    setOutputBuffers(entity, binder, transformRenderer) {
        DEBUG_MODE && rc_js_util_1._Debug.assert(this.point2dBinder.binderClassificationId === binder.binderClassificationId, "attempted to transform inappropriate binder");
        this.bindings.feedbackTransform.bind(transformRenderer);
        this.point2dBinder.setResultBuffers(entity, binder, transformRenderer, transformRenderer.context.STREAM_DRAW);
    }
    performTransform(entity, transformRenderer, updateArg) {
        const ctx = transformRenderer.context;
        this.config[0] = Number(updateArg.userTransform.xTransformEnabled);
        this.config[1] = Number(updateArg.userTransform.yTransformEnabled);
        this.bindings.configUniform.setData(this.config, transformRenderer.sharedState.frameCounter);
        this.bindings.configUniform.bind(transformRenderer);
        this.point2dBinder.update(entity, transformRenderer);
        this.bindings.feedbackTransform.beginTransform(transformRenderer);
        ctx.drawArrays(ctx.POINTS, entity.data.getStart(), entity.data.getLength());
        this.bindings.feedbackTransform.endTransform(transformRenderer);
        this.point2dBinder.clearResultBuffers(transformRenderer);
    }
}
GlPoint2dNaturalLogTransformComponent.factory = new core_1.GlTransformComponentFactory(cartesian2d_natural_log_transform_1.Cartesian2dNaturalLogTransform.transformId, i_gl_indexed_point2d_binder_1.IndexedPoint2dIdentifier, GlPoint2dNaturalLogTransformComponent);
(0, tslib_1.__decorate)([
    rc_js_util_1.Once
], GlPoint2dNaturalLogTransformComponent.prototype, "getCacheId", null);
exports.GlPoint2dNaturalLogTransformComponent = GlPoint2dNaturalLogTransformComponent;
const transformShader = new core_1.GlShader(`
uniform vec2 point2dNaturalLogTransform_config;
void main()
{
    pointConnector_copyAllOutputs();
    pointConnector_setPosition(point2dNaturalLogTransform(pointConnector_getPosition(), point2dNaturalLogTransform_config));
}
`, 300);
//# sourceMappingURL=gl-point2d-natural-log-transform-component.js.map